export const getUploadFolder = (file: File): string => {
  if (file.type.startsWith('video/')) return 'videos';
  if (file.type.startsWith('image/')) return 'photos';
  return 'document';
};
